// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-transition-enter-active[data-v-c080399c],\n.fade-transition-move[data-v-c080399c] {\n  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);\n}\n.fade-transition-leave[data-v-c080399c] {\n  transition-duration: 200ms;\n  width: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
